import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { CartProvider } from './components/CartContext';

// Corporate Layout Components
import CorporateHeader from './components/CorporateHeader';
import CorporateHomePage from './components/CorporateHomePage';
import Footer from './components/Footer';

// Main Pages
import StorePage from './components/StorePage';
import PortfolioPage from './components/PortfolioPage';
import StartProjectPage from './components/StartProjectPage';
import AdminDashboardPage from './components/AdminDashboardPage';
import StartHubPage from './components/StartHubPage';
import PowerMovesPage from './components/PowerMovesPage';

// Landing Pages (QR code destinations)
import MindsetShiftLandingPage from './components/MindsetShiftLandingPage';
import ThisOrThatLandingPage from './components/ThisOrThatLandingPage';
import AuthorsLandingPage from './components/AuthorsLandingPage';

// AI Photoshoots
import AIPhotoshootsPage from './components/AIPhotoshootsPage';
import AIPhotoshootsThankYouPage from './components/AIPhotoshootsThankYouPage';
import AIPhotoshootsIntakePage from './components/AIPhotoshootsIntakePage';

// AI Flyers
import AIFlyersPage from './components/AIFlyersPage';
import AIFlyersThankYouPage from './components/AIFlyersThankYouPage';
import AIFlyersIntakePage from './components/AIFlyersIntakePage';

// Mother's Day Frames
import MothersDayFramesPage from './components/MothersDayFramesPage';
import AvaMaverickPage from './components/AvaMaverickPage';
import AvaMaverickThankYouPage from './components/AvaMaverickThankYouPage';

// Division Pages
import MindsetShiftMediaPage from './components/divisions/MindsetShiftMediaPage';
import AuthorGrowthSystemsPage from './components/divisions/AuthorGrowthSystemsPage';
import PublishingGhostwritingPage from './components/divisions/PublishingGhostwritingPage';
import BrandInfrastructurePage from './components/divisions/BrandInfrastructurePage';
import BusinessDirectoryPage from './components/divisions/BusinessDirectoryPage';

// Existing Revenue Pages (PRESERVED - DO NOT MODIFY)
import AuthorEcosystemSalesPage from './components/AuthorEcosystemSalesPage';
import EcosystemSuccessPage from './components/EcosystemSuccessPage';
import MindsetShiftSoundtrackPage from './components/MindsetShiftSoundtrackPage';
import SoundtrackSuccessPage from './components/SoundtrackSuccessPage';
import MindsetShiftEcosystemPage from './components/MindsetShiftEcosystemPage';

// Legal Pages
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

// UI Components
import { Toaster } from './components/ui/toaster';
import ChiefNavigationOfficer from './components/ChiefNavigationOfficer';

function HomePage() {
  return (
    <>
      <CorporateHeader />
      <CorporateHomePage />
      <Footer />
    </>
  );
}

function App() {
  return (
    <CartProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/store" element={<StorePage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/start-project" element={<StartProjectPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/start" element={<StartHubPage />} />
            <Route path="/powermoves" element={<PowerMovesPage />} />
            
            {/* Landing Pages (QR code destinations) */}
            <Route path="/mindsetshift" element={<MindsetShiftLandingPage />} />
            <Route path="/thisorthat" element={<ThisOrThatLandingPage />} />
            <Route path="/authors" element={<AuthorsLandingPage />} />
            
            {/* AI Photoshoots */}
            <Route path="/ai-photoshoots" element={<AIPhotoshootsPage />} />
            <Route path="/ai-photoshoots/thank-you" element={<AIPhotoshootsThankYouPage />} />
            <Route path="/ai-photoshoots/intake" element={<AIPhotoshootsIntakePage />} />
            <Route path="/photoshoot-intake" element={<AIPhotoshootsIntakePage />} />
            
            {/* AI Flyers */}
            <Route path="/ai-flyers" element={<AIFlyersPage />} />
            <Route path="/ai-flyers/thank-you" element={<AIFlyersThankYouPage />} />
            <Route path="/flyer-intake" element={<AIFlyersIntakePage />} />
            
            {/* Mother's Day Frames */}
            <Route path="/mothers-day-frames" element={<MothersDayFramesPage />} />
            <Route path="/ava-and-maverick" element={<AvaMaverickPage />} />
            <Route path="/ava-and-maverick/thank-you" element={<AvaMaverickThankYouPage />} />
            
            {/* Division Pages */}
            <Route path="/divisions/mindset-shift-media" element={<MindsetShiftMediaPage />} />
            <Route path="/divisions/author-growth-systems" element={<AuthorGrowthSystemsPage />} />
            <Route path="/divisions/publishing-ghostwriting" element={<PublishingGhostwritingPage />} />
            <Route path="/divisions/brand-infrastructure" element={<BrandInfrastructurePage />} />
            <Route path="/divisions/business-directory" element={<BusinessDirectoryPage />} />
            
            {/* Revenue Pages - PRESERVED */}
            <Route path="/author-ecosystem" element={<AuthorEcosystemSalesPage />} />
            <Route path="/ecosystem-success" element={<EcosystemSuccessPage />} />
            <Route path="/mindset-shift-soundtrack" element={<MindsetShiftSoundtrackPage />} />
            <Route path="/mindset-shift-ecosystem" element={<MindsetShiftEcosystemPage />} />
            <Route path="/soundtrack-success" element={<SoundtrackSuccessPage />} />
            
            {/* Legal Pages */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
          
          {/* Chief Navigation Officer - Global floating button */}
          <ChiefNavigationOfficer />
          
          <Toaster />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;